import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "",
    component: () => import("../pages/IdomMain.vue"),
    children: [
      {
        path: "",
        redirect: { name: "channels" },
      },
      {
        path: "users",
        name: "users",
        component: () => import("../components/users/idom-users-main.vue"),
      },
      {
        path: "channels",
        name: "channels",
        component: () =>
          import("../components/channels/idom-channels-main.vue"),
      },
      {
        path: "entities",
        name: "entities",
        component: () =>
          import("../components/entities/idom-entities-main.vue"),
      },
      {
        path: "logs",
        name: "logs",
        component: () => import("../components/logs/idom-logs-main.vue"),
      },
    ],
  },
];

export default routes;
